import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Modal, Typography, IconButton, RadioGroup, Radio, FormControlLabel } from '@mui/material';
import { CloseCircle } from 'iconsax-react';
import React, { useEffect, useState } from 'react';
import { UploadAction } from '../../../components/common/actions/UploadAction';
import { WidgetHeader } from '../../../components/common/header/widgetHeader/WidgetHeader';
import { black500 } from '../../../constants/color';
import CustomSelect from '@ui/components/common/inputs/CustomSelect';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { getFreelancerAssignmentByStatusAsync, updateAssignmentContractAsync } from '@application/features/assignments/assignmentThunk';
import { ClientContractStatus } from '@application/common/enums/client-contract-status';
import { translate } from '@application/common/helpers/translate';
import { Controller, useForm } from 'react-hook-form';
import { DownloadAction } from '@ui/components/common/actions/DownloadAction';
import { QCheckbox } from '@ui/components/common/Qcheckbox/QCheckbox';
import { OutlineButon } from '@ui/components/common/button/OutlineButton';
import { PrimaryButon } from '@ui/components/common/button/PrimaryButon';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 626,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '25px'
};
export const ContractModal = ({ handleClose, open }) => {
    const { Assignments } = useAppSelector((state) => state.assignment);
    const [isFileUploaded, setisFileUploaded] = useState(false);
    const [isTermsChecked, setIsTermsChecked] = useState(false);
    const [uploadedFile, setUploadedFile] = useState(null);
    const [signingMethod, setSigningMethod] = useState('manual');
    const [editFile, setEditFile] = useState(false);
    const dispatch = useAppDispatch();
    const { control, handleSubmit, formState: { errors }, setValue, setError, clearErrors, reset } = useForm({});
    useEffect(() => {
        dispatch(getFreelancerAssignmentByStatusAsync(ClientContractStatus.PendingSignature));
    }, [dispatch, open]);
    const Clear = () => {
        setEditFile(false);
        setUploadedFile(null);
        setisFileUploaded(false);
        setValue('Contract', undefined);
        setError('Contract', { message: translate('validations.fieldIsRequired') });
    };
    const HandleClose = () => {
        reset({
            ClientId: '',
            Contract: undefined
        });
        setUploadedFile(null);
        setisFileUploaded(false);
        setEditFile(false);
        clearErrors('Contract');
        handleClose();
    };
    const handleFileUpload = (file) => {
        const maxFileSize = 16777216;
        const uploadedFile = file;
        setisFileUploaded(true);
        if (uploadedFile) {
            if (!['application/pdf'].includes(uploadedFile.type))
                setError('Contract', {
                    message: translate('validations.onlyPDFAllowed')
                });
            else if (uploadedFile.size > maxFileSize) {
                setError('Contract', {
                    message: translate('validations.maxAllowedFileSize')
                });
            }
            else {
                setValue('Contract', uploadedFile);
                setUploadedFile(uploadedFile);
                clearErrors('Contract');
            }
        }
        else {
            setValue('Contract', undefined);
            setUploadedFile(null);
            setisFileUploaded(false);
            clearErrors('Contract');
        }
    };
    const onSubmit = (clientContract) => {
        dispatch(updateAssignmentContractAsync(clientContract))
            .unwrap()
            .then((response) => {
            HandleClose();
        });
    };
    return (_jsx(_Fragment, { children: _jsx(Modal, { open: open, onClose: handleClose, "aria-labelledby": 'modal-modal-title', "aria-describedby": 'modal-modal-description', children: _jsxs(Box, { sx: {
                    ...style,
                    width: { xs: 400, md: 626 },
                    maxHeight: 'calc(100% - 20px)',
                    minHeight: '616px',
                    display: 'flex',
                    flexDirection: 'column'
                }, children: [_jsxs(WidgetHeader, { background: 'white', children: [_jsx(Typography, { fontWeight: 500, fontSize: '20px', color: 'black', children: "Upload signed contract" }), _jsx(IconButton, { onClick: HandleClose, children: _jsx(CloseCircle, { style: { color: 'black' } }) })] }), _jsxs(Box, { sx: {
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            px: 2,
                            pb: 2,
                            overflow: 'hidden'
                        }, children: [_jsxs(Box, { flex: '1 1 auto', overflow: 'auto', pr: 1, children: [_jsxs(Box, { children: [_jsx(Typography, { variant: 'subtitle2', color: black500, children: "Clients" }), _jsx(Controller, { name: 'ClientId', control: control, defaultValue: '', rules: {
                                                    required: { value: true, message: translate('validations.fieldIsRequired') }
                                                }, render: ({ field }) => (_jsx(CustomSelect, { label: 'Clients', options: Assignments
                                                        ? Assignments.map((client) => ({
                                                            label: client.clientName,
                                                            value: client.id
                                                        }))
                                                        : [], selectedOption: field.value, handleChange: (value) => field.onChange(value), errormsg: errors.ClientId ? errors.ClientId.message : '' })) })] }), _jsxs(Box, { mt: 3, children: [_jsx(Typography, { variant: 'subtitle2', color: black500, children: "Signing Method" }), _jsxs(RadioGroup, { value: signingMethod, onChange: (e) => setSigningMethod(e.target.value), children: [_jsx(FormControlLabel, { value: 'manual', control: _jsx(Radio, {}), label: _jsx(Typography, { variant: 'body1', children: "Manual Upload \u2013 Upload a signed contract manually" }) }), _jsx(FormControlLabel, { value: 'docusign', control: _jsx(Radio, {}), label: _jsx(Typography, { variant: 'body1', children: "Sign via DocuSign \u2013 Sign digitally via DocuSign" }) })] }), signingMethod === 'docusign' && (_jsx(Typography, { variant: 'subtitle2', color: black500, mt: 1, children: "You\u2019ll be redirected to DocuSign to complete signing." })), signingMethod === 'manual' && (_jsxs(_Fragment, { children: [_jsxs(Box, { children: [_jsx(Typography, { variant: 'subtitle2', color: black500, children: "Contract" }), editFile || errors.Contract || !isFileUploaded ? (_jsx(Controller, { name: 'Contract', control: control, rules: {
                                                                    required: {
                                                                        value: true,
                                                                        message: translate('validations.fieldIsRequired')
                                                                    },
                                                                    validate: {
                                                                        fileType: (file) => {
                                                                            if (file && !['application/pdf'].includes(file.type)) {
                                                                                return translate('validations.onlyPDFAllowed');
                                                                            }
                                                                            return true;
                                                                        },
                                                                        fileSize: (file) => {
                                                                            if (file && file.size > 16777216) {
                                                                                return translate('validations.maxAllowedFileSize');
                                                                            }
                                                                            return true;
                                                                        }
                                                                    }
                                                                }, render: ({ field }) => (_jsx(UploadAction, { onFileUpload: (file) => {
                                                                        field.onChange(file);
                                                                        handleFileUpload(file);
                                                                    }, h: isFileUploaded ? 85 : 173, py: isFileUploaded ? 0 : 15, px: isFileUploaded ? 4 : 0, variant: isFileUploaded ? 'outLined' : 'contained', text: 'Upload signed agreement', errormsg: errors.Contract ? errors.Contract.message : '' })) })) : (isFileUploaded &&
                                                                !errors.Contract && (_jsx(DownloadAction, { fileName: uploadedFile?.name, width: '100%', type: 'upload', clear: Clear })))] }), _jsx(Box, { display: 'flex', alignItems: 'center', gap: 1, my: 1.5, sx: { cursor: 'pointer' }, children: _jsx(Controller, { name: 'terms', control: control, defaultValue: false, rules: {
                                                                required: { value: true, message: translate('validations.fieldIsRequired') }
                                                            }, render: ({ field }) => (_jsx(QCheckbox, { ...field, label: 'I agree to the QGROUP terms and conditions', onChange: (event) => field.onChange(event.valueOf()), checked: field.value, errormsg: errors.terms ? errors.terms.message : '' })) }) })] }))] })] }), _jsxs(Box, { display: 'flex', gap: 2, alignItems: 'center', children: [_jsx(OutlineButon, { onClick: handleClose, children: "Cancel" }), _jsx(PrimaryButon, { type: 'submit', onClick: handleSubmit(onSubmit), children: signingMethod === 'manual' ? 'Save' : 'Send Envelope' })] })] })] }) }) }));
};
